<template>
  <div>
    <div class="header">IMPORT RSVP</div>
    <div class="import-rsvp">
      <div class="v-center">
        <div class="import-box">
          <div class="input-box">
            <div class="row">
              <div class="small-6 columns end">
                <div class="data-field">
                  <div class="label">Service Map</div>
                  <select v-model="serviceMapping" :disabled="brandLoading">
                    <option value="">Default</option>
                    <option value="qa-test" v-if="isStaging">QA-Staging</option>
                    <option v-for="data in serviceMappingValues" :value="data.key" :key="data.key">{{ data.name }}</option>
                  </select>
                  <span class="error-msg">{{ validation.serviceMapping }}</span>
                </div>
              </div>

              <div class="small-6 columns end">
                <div class="data-field">
                  <div class="label">Source</div>
                  <input type="text" :class="{'input':true, 'has-error':!!validation.source}" v-model="source" />
                  <span class="error-msg">{{ validation.source }}</span>
                </div>
              </div>

              <div class="small-12 columns end">
                <div class="data-field">
                  <div class="label">Upload CSV</div>
                  <input type="file" ref="uploadInput" />
                  <span class="error-msg">{{ fileError }}</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="small-12 columns end">
                <span class="note">
                  <b>Note:</b> Confirmation Email and SMS will be sent to the consumers contained within the CSV file to be uploaded
                </span>
              </div>
            </div>

            <div class="row">
              <div class="small-12 columns end p-T-10">
                <button :class="{'button small block':true, 'disabled':uploading}" @click="upload">
                  {{ buttonLabel }}
                  <i class="fas fa-spin fa-spinner" v-if="uploading"></i>
                </button>
              </div>
            </div>
          </div>

          <transition name="slide-down">
            <div class="rsvp-box" v-if="rsvps.list.length">
              <div v-for="(rsvp, index) in rsvps.list" :key="rsvp.id" :class="{
                'rsvp-item': true,
                'success': rsvpStatus.success.indexOf(rsvp.id) > -1,
                'on-going': rsvpStatus.onGoing.indexOf(rsvp.id) > -1,
                'failed': rsvpStatus.failed.indexOf(rsvp.id) > -1
              }">
                <div class="info">
                  <span class="index">{{ index + 1 }}</span>
                  <span class="name">{{ rsvp.data.custFirstName + ' ' + rsvp.data.custLastName }}</span>
                  <span class="email">{{ rsvp.data.custEmail }}</span>
                </div>
                <div class="action">
                  <span v-if="rsvpStatus.success.indexOf(rsvp.id) > -1">
                    <a :href="'/#/reservation/' + rsvp.rsvpId" target="_blank" >RSVP #{{ rsvp.rsvpId }}</a>
                  </span>
                  <i class="fas fa-spin fa-spinner" v-if="rsvpStatus.onGoing.indexOf(rsvp.id) > -1"></i>
                  <i class="fas fa-sync" v-if="rsvpStatus.failed.indexOf(rsvp.id) > -1" @click="createRsvp(rsvp.id, true)"></i>
                </div>
                <div class="clearfix"></div>
                <div class="error-msg" v-if="!!errorMessage(rsvp.id)">
                  <span>{{ errorMessage(rsvp.id).msg }}</span>
                  <div>{{ errorMessage(rsvp.id).debug }}</div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <transition name="slide-up">
      <div class="control-box" v-show="rsvps.processing.length">
        <div class="control">
          <div v-if="processing" @click="pauseProcess">
            <i class="fas fa-pause"></i> STOP
          </div>
          <div v-else @click="beginCreateRsvp">
            <i class="fas fa-play"></i> CONTINUE
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global CONFIG */
export default {
  name: 'import-rsvp',
  data () {
    return {
      brand: '',
      brandLoading: false,
      serviceMapping: '',
      serviceMappingValues: [],
      source: '',
      uploading: false,
      fileUrl: '',
      fileError: '',
      buttonLabel: 'Submit',
      rsvps: {
        list: [],
        processing: []
      },
      processing: false,
      processCount: 1,
      rsvpStatus: {
        success: [1, 2, 3],
        onGoing: [5, 7, 8],
        failed: [4, 6]
      },
      rsvpErrors: [],
      validation: {
        brand: ''
      },
      submitLoading: false,
      processLoading: false,
      forceStop: false
    }
  },
  computed: {
    brands () { return this.$store.state.brands.list },
    isStaging () { return CONFIG.Env !== 'production'}
  },
  methods: {
    getBrands () {
      let self = this
      self.brandLoading = true
      self.$sdk.get('/import/mappings', {token: self.$store.state.session.sessionToken}, res => {
        self.brandLoading = false
        if (res.error) { return }

        if (res.list.length) {
          self.serviceMappingValues = res.list
          // self.$store.commit('brands/setList', res)
        }
      }, '2.0')
    },
    upload () {
      let self = this
      if (self.validate() || self.uploading) { return }

      self.buttonLabel = 'Uploading CSV...'
      self.uploading = true

      let file = self.$refs.uploadInput.files[0]
      let fd = new FormData()
      fd.append('pic', file)

      self.fileUrl = ''
      self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
        header: {'Content-Type': 'multipart/form-data'}
      }).then(function (res) {
        this.uploading = false
        if (!res.body.success) {
          self.buttonLabel = 'Submit'
          // self.$store.commit('provider/showUploadError', true)
        } else {
          self.buttonLabel = 'Processing reservations...'
          self.fileUrl = res.body.data.url
          self.submitData()
        }
      }, function (res) {
        console.log('error', res)
        // self.$store.commit('provider/showUploadError', true)
      })
    },
    validate () {
      let self = this
      let hasError = false
      // for (let field in self.validation) {
      //   self.validation[field] = ''
      //   if (self[field] === '') {
      //     self.validation[field] = 'This field cannot be empty.'
      //     hasError = true
      //   }
      // }

      if (!self.$refs.uploadInput.files.length) {
        this.fileError = 'Missing CSV file.'
        hasError = true
      }

      return hasError
    },
    submitData () {
      let self = this
      if (self.submitLoading || self.processLoading) { return }
      self.submitLoading = true
      self.rsvpStatus = { success: [], onGoing: [], failed: [] }
      self.processCount = 1

      if (!self.serviceMapping) {
        self.brand = CONFIG.Env === 'production' ? 2 : 8
      } else if (self.serviceMapping === 'qa-test') {
        self.brand = CONFIG.Env === 'production' ? 4 : 12
      } else {
        let serviceIndex = self.serviceMappingValues.findIndex(x => x.key === self.serviceMapping)
        console.log(serviceIndex, self.serviceMapping)
        self.brand = self.serviceMappingValues[serviceIndex].brandId
      }

      self.$sdk.post('/import', {
        token: self.$store.state.session.sessionToken,
        csvUrl: self.fileUrl,
        brandId: self.brand,
        source: self.source,
        serviceMapping: self.serviceMapping
      }, res => {
        console.log('-', res)
        self.submitLoading = false
        self.rsvps = {
          list: [],
          processing: []
        }
        if (!res.error) {
          if (res.list.length) {
            res.list.forEach(data => {
              self.rsvps.list.push({
                id: data.id,
                data: data.data
              })
              self.rsvps.processing.push(data.id)
            })
            setTimeout(function () {
              self.processLoading = true
              self.beginCreateRsvp()
            }, 600)
          }
        } else {
          self.buttonLabel = 'Submit'
        }
      }, '2.0')
    },
    beginCreateRsvp () {
      let self = this
      if (!self.rsvps.processing.length || self.forceStop) {
        self.processLoading = false
        self.processing = false
        self.buttonLabel = 'Submit'

        if (self.forceStop) {
          self.forceStop = false
        }
        return
      }
      self.processing = true

      let loopCount = self.rsvps.processing.length <= self.processCount ? self.rsvps.processing.length : self.processCount
      for (let x = 0; x < loopCount; x++) {
        if (self.rsvps.processing.length) {
          self.createRsvp(self.rsvps.processing[0], false)
          self.rsvps.processing.shift()
          self.processCount--
        }
      }

      // setTimeout(function () {
      //   self.beginCreateRsvp()
      // }, 300)
    },
    createRsvp (id, isManual) {
      let self = this

      let failedIndex = self.rsvpStatus.failed.indexOf(id)
      if (failedIndex > -1) {
        self.rsvpStatus.failed.splice(failedIndex, 1)
      }
      self.rsvpStatus.onGoing.push(id)

      self.$sdk.post('/import/' + id, {token: self.$store.state.session.sessionToken}, res => {
        let onGoingIndex = self.rsvpStatus.onGoing.indexOf(id)
        if (onGoingIndex > -1) {
          self.rsvpStatus.onGoing.splice(onGoingIndex, 1)
        }

        if (!res.error) {
          self.rsvpStatus.success.push(id)
          let rsvpIndex = self.rsvps.list.findIndex(x => x.id === id)
          if (rsvpIndex > -1) {
            self.rsvps.list[rsvpIndex].rsvpId = res.reservationId
          }
        } else {
          let debug = ''
          if (res.error.message === 'Request is not valid') {
            debug = 'Invalid fields: ' + Object.keys(res.error.fields).join(', ')
          } else if (res.error.debug && typeof res.error.debug === 'string') {
            debug = res.error.debug
          }
          self.rsvpErrors.push({
            id: id,
            msg: res.error.message,
            debug: debug
          })
          self.rsvpStatus.failed.push(id)
        }

        if (!isManual) {
          self.processCount++
          self.beginCreateRsvp()
        }
      }, '2.0')
    },
    errorMessage (id) {
      let index = this.rsvpErrors.findIndex(x => x.id === id)
      return index > -1 ? this.rsvpErrors[index] : { msg: '', debug: '' }
    },
    pauseProcess () {
      this.forceStop = true
      this.processing = false
    }
  },
  mounted () {
    this.getBrands()
  }
}
</script>

<style lang="scss" scoped>
.header {
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 22px;
  padding: 14px 0 14px 64px;
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
}

.import-rsvp{
  width: 100%;
  display: table;
}

.v-center{
  display: table-cell;
  vertical-align: middle;
}

.import-box{
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.35);
  width: 100%;
  margin: 0 auto;
  max-width: 800px;

  .input-box{
    border: 2px dashed #b7a711;
    padding: 15px;
    border-radius: 4px;
    margin-top: 5px;
    background: #fbf9e6;

    .fa-spin{ margin-left: 3px; }
    .note{
      font-size: 13px;
      font-style: italic;
      padding: 0 5px;
      color: #555;
      display: block;
    }
  }
  .rsvp-box{
    margin-top: 10px;
    padding: 15px;
    border-radius: 4px;
    border: 2px solid #ccc;

    .rsvp-item{
      border: 1px solid #888;
      font-size: 14px;
      margin-bottom: 8px;
      text-align: left;
      border-radius: 2px;
      position: relative;

      &.success{
        border-color: #09a63a;
        background: #e1ffea;
        color: #09a63a;

        a{ color: #09a63a; }
      }
      &.failed{
        border-color: #f23333;
        // background: #fde3e3;
        color: #f23333;
      }
      &.on-going{
        border-color: #c56a0d;
        background: #fbfaea;
        color: #c56a0d;
      }
      .info{
        padding: 5px;
        width: calc(100% - 130px);
        float: left;

        span{
          display: inline-block;
          vertical-align: middle;
        }
        .index{
          min-width: 30px;
          text-align: center;
          margin-right: 3px;
          font-weight: 600;
        }
        .email{
          margin-left:5px;
          font-size: 13px;
          opacity: .75;
        }
      }
      .action{
        max-width: 130px;
        min-width: 50px;
        float: right;
        padding: 5px;
        text-align: center;
      }
      .fa-sync{ cursor: pointer; }
      .error-msg{
        background: #fde3e3;
        color: #f23333;
        font-style: italic;
        padding: 2px 5px;
        font-size: 13px;
      }
    }
  }
}

.clearfix{ clear:both; }
.p-R-10{ padding-right: 10px; }
.p-T-10{ padding-top: 10px; }

.data-field{
  padding: 5px;
  position: relative;

  .label{
    color: #888;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;

    &.has-error{ color: #f20d0d; }
  }
  .input{
    margin: 1px 0 0;
    padding: 5px;
    font-size: 14px;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

select{
  padding: 5px 25px 5px 5px;
  height: 30px;
  font-size: 14px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;

  &[disabled]{ background-color: #ebebe4; }
}
input[type="file"]{
  margin-top: 0;
  padding: 4px;
  font-size: 14px;
  background: #fdfdfd;
}

.control-box{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  .control{
    margin: 0 auto;
    width: 100%;
    max-width: 800px;
    border-radius: 4px 4px 0 0;
    height: 50px;
    line-height: 50px;
    font-size: 21px;
    cursor: pointer;
    text-align: center;
    background: #c5d0dc;
  
    i{ margin-right: 4px; }
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(30px);
  opacity: 0;
}
.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .small-6 {
    width: 100%;
  }

  .p-T-10 {
    padding-top: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ImportRsvp/index.vue